module.exports = __webpack_public_path__ + "static/media/unit 5-2.df92ca2e.jpg";